const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	sections : [],
}

const getters = {
	fetchSections : (state) => state.sections,
}

const actions = {
	loadSections({commit}, {token}){
		return $http.get(`section`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_SECTIONS', response.data.data)
		})
	},
	

    // updateTeacher({commit}, {id, teacher, token}){
	// 	// let category_formdata = new FormData()
	// 	// for(let key in category){
	// 	// 	if(key == 'categoryfiles'){
	// 	// 		for(let i in category[key]){
	// 	// 			category_formdata.append(`${key}`, category[key][i])
	// 	// 		}
	// 	// 	}else if(key == 'editfiles'){
	// 	// 		category_formdata.append(key, JSON.stringify(category[key]))
	// 	// 	}else{
	// 	// 		category_formdata.append(key, category[key])
	// 	// 	}	
	// 	// }

	// 	for(let key in teacher){
	// 		if(teacher[key] == null){
	// 			delete teacher[key]
	// 		}
	// 	}
		
	// 	return $http.put(`user/${id}`, teacher, {
	// 		headers : {
	// 			// 'Content-Type' : 'undefined',
	// 			'x-auth-token' : token
	// 		}
	// 	}).then((response) => {
	// 		commit('UPDATE_TEACHER', response.data)
	// 	})
	// },

	// deleteTeacher({commit}, {id, token}){
	// 	return $http.delete(`user/${id}`, {
	// 		headers : {
	// 			'x-auth-token' : token
	// 		} 
	// 	}).then(() => {
	// 		commit('REMOVE_TEACHER', id)	
	// 	})
	// },
}

const mutations = {
	SET_SECTIONS : (state, sections) => {
		state.sections = sections
	},
	
	// UPDATE_CATEGORY : (state, category) => {
	// 	state.current_category = category
	// 	let cat_index = state.categories.findIndex(category_obj => category_obj._id == category._id)
	// 	Vue.set(state.categories, cat_index, Object.assign({}, category)) // For making it reactive
	// },
	// REMOVE_CATEGORY : (state, category_id) => {
	// 	state.categories = state.categories.filter(category => category._id != category_id)
	// 	if(state.current_category && (state.current_category._id == category_id)){
	// 		state.current_category = null
	// 	}
	// },
}

export default {
	state, getters, actions, mutations
}